import React, { Component } from "react";
import classnames from "classnames";
import { createEditorState, onError, onSuccess } from "Utils";
import { saveExtraSlide, fetchExtraSlideList } from "Thunks";
import {
  setExtraSlideListPaginationPage,
  setVisibilityExtraSlide,
  setCategorySelectedItem
} from "Actions";

import styles from "./ExtraSlides.local.scss";
import _ from "i18n";
import RichEditor from "../Common/editor/RichEditor";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import { connect } from "react-redux";
import { Option, Select } from "../UI/form";
import { setSearchTitleExtraSlide } from "../../actions/actions";

class ExtraSlideSideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      extraSlideContent: createEditorState(""),
      title: "",
      content: "",
      category: {
        categoryValue: " non catégorisé ",
        categoryId: null
      }
    };
  }
  componentDidUpdate(previousProps, previousState) {
    const { isUpdate, slideToUpdate, categorySettings } = this.props;
    if (
      slideToUpdate &&
      isUpdate &&
      previousProps.slideToUpdate !== this.props.slideToUpdate
    ) {
      this.setState({
        ...this.state,
        category: {
          categoryValue:
            slideToUpdate.category.id &&
            categorySettings.categoryList.filter(
              ({ id }) => id === slideToUpdate.category.id
            )[0]
              ? categorySettings.categoryList.filter(
                  ({ id }) => id === slideToUpdate.category.id
                )[0].label
              : " non catégorisé ",
          categoryId: slideToUpdate.category.id
        },
        title: slideToUpdate.label,
        extraSlideContent: createEditorState(
          slideToUpdate.layout.components[0].content
        ),
        content: slideToUpdate.layout.components[0].content
      });
    }
  }

  handleChangeExtraSlideContent = event => {
    this.setState({
      ...this.state,
      extraSlideContent: event,
      content: draftToHtml(convertToRaw(event.getCurrentContent())).slice(0, -1)
    });
  };

  handleSaveExtraSlide = () => {
    const { title, content, category } = this.state;
    const { dispatch, isUpdate, slideToUpdate } = this.props;

    if (isUpdate && slideToUpdate && slideToUpdate.id) {
      dispatch(
        saveExtraSlide(
          title,
          content,
          slideToUpdate.id,
          null,
          category.categoryId
        )
      )
        .then(resp => {
          dispatch(setSearchTitleExtraSlide(""));
          dispatch(setVisibilityExtraSlide("-1"));
          dispatch(setCategorySelectedItem([]));
          dispatch(setExtraSlideListPaginationPage(1));
          dispatch(fetchExtraSlideList("-1", "", []));

          this.handleCancelNewExtraSlide();
          return (async () =>
            onSuccess(resp, {
              title: _("updateSuccess")
            }))();
        })
        .catch(err => {
          return (async () => onError(err))();
        });
    } else {
      dispatch(saveExtraSlide(title, content, null, null, category.categoryId))
        .then(resp => {
          dispatch(setSearchTitleExtraSlide(""));
          dispatch(setVisibilityExtraSlide("-1"));
          dispatch(setCategorySelectedItem([]));
          dispatch(setExtraSlideListPaginationPage(1));
          dispatch(fetchExtraSlideList("-1", "", []));
          return (async () =>
            onSuccess(resp, {
              title: _("saveSuccess")
            }))();
        })
        .catch(err => {
          return (async () => onError(err))();
        });
    }
    this.setState({
      extraSlideContent: createEditorState(""),
      title: "",
      content: "",
      category: {
        categoryValue: " non catégorisé ",
        categoryId: null
      }
    });
  };
  handleCancelNewExtraSlide = () => {
    this.props.onCancelNewExtraSlide();
    this.setState({
      extraSlideContent: createEditorState(""),
      title: "",
      content: "",
      category: {
        categoryValue: " non catégorisé ",
        categoryId: null
      }
    });
  };

  handleChangeTitle = event => {
    this.setState({
      ...this.state,
      title: event.target.value
    });
  };

  handleChangeCategory = value => {
    this.setState({
      ...this.state,
      category: {
        categoryId:
          this.props.categorySettings.categoryList.filter(
            ({ label }) => label === value
          )[0] &&
          this.props.categorySettings.categoryList.filter(
            ({ label }) => label === value
          )[0].id,
        categoryValue: value
      }
    });
  };
  render() {
    const {
      isAddingExtraSlide,
      saving,
      slideToUpdate,
      categorySettings
    } = this.props;
    const { extraSlideContent, title, content, category } = this.state;
    return (
      <div
        className={classnames(
          styles.sidebar,
          isAddingExtraSlide ? styles.display : ""
        )}
      >
        <img
          src={"/img/icons/close.svg"}
          className={styles.sidebar__close}
          onClick={this.handleCancelNewExtraSlide}
          alt={""}
        />
        <div className={styles.sidebar__titles}>
          <h4>{_("addExtaSLide")}</h4>
        </div>
        <div className={styles.labels_form_block}>
          <div style={{ display: "flex", marginLeft: "22px" }}>
            <div>
              <span className={styles.span_label}>
                {_("title")}
                {" :"}
              </span>
              <div className={styles.div_input}>
                <input
                  type={"text"}
                  placeholder={_("title")}
                  value={title}
                  onChange={this.handleChangeTitle}
                  required={true}
                />
                <img src={"/img/icons/pencil.svg"} alt={""} />
              </div>
            </div>

            <div>
              <span className={styles.span_label}>
                {_("category")}
                {" :"}
              </span>
              <Select
                onChange={this.handleChangeCategory}
                className={styles.select_option}
                value={category.categoryValue}
              >
                <Option value={"non catégorisé"} key={-1}>
                  {"non catégorisé"}
                </Option>
                {categorySettings.categoryList
                  ? categorySettings.categoryList.map((item, index) => {
                      return (
                        <Option value={item.label} key={item.id}>
                          {item.label}
                        </Option>
                      );
                    })
                  : ""}
              </Select>
            </div>
          </div>

          <span
            className={styles.span_label}
            style={{ marginTop: "30px", marginBottom: "-14px" }}
          >
            {_("content")}
            {" :"}
          </span>
          <div style={{ width: "745px", marginLeft: "40px" }}>
            <RichEditor
              isExtraSlide={true}
              content={extraSlideContent}
              onEditorChange={this.handleChangeExtraSlideContent}
            />
          </div>
          <div className={styles.actions_block}>
            <button
              className={styles.cancel_btn}
              onClick={this.handleCancelNewExtraSlide}
            >
              {_("cancel")}
            </button>
            {slideToUpdate &&
            slideToUpdate.layout.components[0].content &&
            slideToUpdate.layout.components[0].content.length > 8 ? (
              <button
                disabled={
                  title !== "" && content && content.length > 8 ? false : true
                }
                className={styles.save_button}
                onClick={this.handleSaveExtraSlide}
              >
                <img
                  src={"/img/icons/tail-spin.svg"}
                  alt={""}
                  className={saving ? styles.loading : ""}
                />
                {_("update")}
              </button>
            ) : (
              <button
                disabled={
                  title !== "" && content && content.length > 8 ? false : true
                }
                className={styles.save_button}
                onClick={this.handleSaveExtraSlide}
              >
                <img
                  src={"/img/icons/tail-spin.svg"}
                  alt={""}
                  className={saving ? styles.loading : ""}
                />
                {_("save")}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  saving: state.extraSlideList.saving,
  organizationUen: state.auth.currentOrganization.uen,
  paginationPage: state.extraSlideList.paginationPage,
  visibility: state.extraSlideList.filter.visibility,
  categorySettings: state.extraSlideList.categorySettings,
  searchTitle: state.extraSlideList.filter.searchTitle,
  categoryListSelected: state.extraSlideList.filter.category
});
export default connect(mapStateToProps)(ExtraSlideSideBar);



// WEBPACK FOOTER //
// ./src/components/ExtraSlides/ExtraSlideSideBar.js